import { useMemo } from 'react'

import { useLineChart } from './use-line-chart'

interface Props {
  dataKey: string
  noDropLine?: boolean
  render?: () => React.ReactNode
}

export const LineChartActiveMarker: React.FC<Props> = ({ dataKey, noDropLine = false, render }) => {
  const { activeIndex, dataSets, xScale, yScale, plotAreaHeight, plotAreaPadding } = useLineChart()

  const point = useMemo(() => {
    if (activeIndex === null) {
      return null
    }

    const dataSet = dataSets[dataKey]
    const activeData = dataSet?.[activeIndex] ?? null

    const x = xScale(activeIndex)
    const y = activeData === null ? null : yScale(activeData)

    return { x, y }
  }, [activeIndex, dataSets, dataKey, xScale, yScale])

  if (point === null) {
    return null
  }

  if (point.y === null) {
    return null
  }

  return (
    <g transform={`translate(${point.x}, ${point.y})`}>
      {!noDropLine && (
        <line
          x1={0}
          y1={0}
          x2={0}
          y2={plotAreaHeight + (plotAreaPadding?.top ?? 0) - point.y}
          stroke="hsla(215, 20%, 65%, 1)"
          strokeWidth={1}
        />
      )}
      {render ? (
        render()
      ) : (
        <>
          <circle r="6.5" fill="hsla(228, 55%, 42%, 0.2)" />
          <circle r="4.5" fill="hsla(228, 55%, 42%, 1)" />
        </>
      )}
    </g>
  )
}
